import React, { Component } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import API from 'utils/API'
import hotjarTrigger from 'utils/hotjarTrigger'
import csrfToken from 'utils/csrfToken'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import {
  Input,
  FormGroup,
  Label,
  Image,
} from 'components/qstrap'
import RadioButton from './RadioButton'
import SubmitButton from './SubmitButton'
import SubmitMessage from './SubmitMessage'

class AutoCompleteSearchNotFound extends Component {
  state = {
    type: 'Kampus',
    description: '',
    hidden: true,
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  sendFeedBack = () => {
    axios({
      url: API.endPoints().search.not_found,
      method: 'post',
      dataType: 'json',
      data: {
        type: this.state.type,
        description: this.state.description,
        keyword: this.props.keyword,
      },
      headers: {
        'X-CSRF-Token': csrfToken(),
      },
    })

    this.setState(prevState => ({
      hidden: !prevState.hidden,
    }), () => {
      hotjarTrigger('submit_not_found')
    })
  }

  render() {
    return (
      <>
        <div className="container container--not-found" hidden={!this.state.hidden}>
          <Row>
            <Col md="12">
              <div className="top-section">
                <div className="img-wrapper">
                  <Image src="/assets/img/search/woman-walking-1.png" alt="walking woman"/>
                </div>
                <div className="text-wrapper">
                  <div>
                    <p className="title font-weight-bold">{`Oops, pencarian untuk "${this.props.keyword}" tidak ditemukan`}</p>
                    <p>Ayo bantu Quipper Campus untuk lebih hebat lagi dengan mengisi form berikut:</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <FormGroup>
                <Label>Deskripsikan yang ingin kamu cari</Label>
                <Input
                  type="textarea"
                  name="description"
                  className="text-area"
                  value={this.state.description}
                  onChange={this.handleChange}
                />
                <Label>Kategori</Label>
                <RadioButton
                  name="type"
                  selectOptions={['Kampus', 'Jurusan', 'Lokasi', 'Karier', 'Beasiswa', 'Lainnya']}
                  handleChange={this.handleChange}
                  defaultValue="Kampus"
                />
                <div className="btn-wrapper">
                  <SubmitButton className="submit-feedback" onClick={this.sendFeedBack}>Kirim</SubmitButton>
                </div>
              </FormGroup>
            </Col>
          </Row>
          <style jsx>{`
            .container--not-found {
              margin: 8px 12px;
            }
            :global(.text-area) {
              height: 38px;

              @media(max-width: 577px) {
                height: 98px
              }
            }

            :global(.submit-feedback) {
              @media(max-width: 577px) {
                width: 100% !important;
              }
            }

            .top-section {
              display: flex;
              flex-wrap: wrap;
            }

            .img-wrapper {
                margin: 32px auto;
            }

            .text-wrapper {
              display: flex;
              margin: auto;

              @media(max-width: 577px) {
                text-align: center;
              }
            }

            .btn-wrapper{
              display: flex;
              justify-content:center;
            }
            .container {
              padding: 1%;
            }

            .title {
              color: #1e3f6b;
              font-size: 16px !important;
              margin-bottom: 16px;
            }

            p {
              font-size: 14px !important;
            }
          `}
          </style>
        </div>
        <SubmitMessage hidden={this.state.hidden} />
      </>
    )
  }
}

AutoCompleteSearchNotFound.propTypes = {
  keyword: PropTypes.string,
}

export default AutoCompleteSearchNotFound
